/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.SettingsRpc
 */

export const ConsentErrorTypename = 'com.hubspot.portals.platform.models.rpc.ConsentError';
export const ConsentErrorDiscriminant = 'CONSENT';
export const ConsentErrorDiscriminantKey = '@type';
export const CustomerSuccessPortalErrorTypename = 'com.hubspot.portals.platform.models.rpc.CustomerSuccessPortalError';
export const CustomerSuccessPortalErrorDiscriminant = 'CUSTOMER_SUCCESS_PORTAL';
export const CustomerSuccessPortalErrorDiscriminantKey = '@type';
export const NotificationErrorTypename = 'com.hubspot.portals.platform.models.rpc.NotificationError';
export const NotificationErrorDiscriminant = 'NOTIFICATION';
export const NotificationErrorDiscriminantKey = '@type';
export const PortalAuthErrorTypename = 'com.hubspot.portals.platform.models.rpc.PortalAuthError';
export const PortalAuthErrorDiscriminant = 'AUTH';
export const PortalAuthErrorDiscriminantKey = '@type';
export const PortalPublicRpcErrorDiscriminantKey = '@type';
export const SettingsErrorTypename = 'com.hubspot.portals.platform.models.rpc.SettingsError';
export const SettingsErrorDiscriminant = 'SETTINGS';
export const SettingsErrorDiscriminantKey = '@type';
export const SupportPortalErrorTypename = 'com.hubspot.portals.platform.models.rpc.SupportPortalError';
export const SupportPortalErrorDiscriminant = 'SUPPORT_PORTAL';
export const SupportPortalErrorDiscriminantKey = '@type';
export const TrackEventErrorTypename = 'com.hubspot.portals.platform.models.rpc.TrackEventError';
export const TrackEventErrorDiscriminant = 'TRACK_EVENT';
export const TrackEventErrorDiscriminantKey = '@type';
export const TranslationsErrorTypename = 'com.hubspot.portals.platform.models.rpc.translations.TranslationsError';
export const TranslationsErrorDiscriminant = 'TRANSLATIONS';
export const TranslationsErrorDiscriminantKey = '@type';
export const getUserSettingsRpc = {
  serviceName: 'com.hubspot.portals.platform.app.rpc.SettingsRpc',
  rpcName: 'getUserSettings',
  auth: 'external',
  fingerprint: 'N2ir_es5XSbR8at58yF5cHOjsnBdk3FP',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateUserSettingsRpc = {
  serviceName: 'com.hubspot.portals.platform.app.rpc.SettingsRpc',
  rpcName: 'updateUserSettings',
  auth: 'external',
  fingerprint: 'IOR5i-I3WKK5bojujrizi3OjsnBdk3FP',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const uploadProfilePhotoRpc = {
  serviceName: 'com.hubspot.portals.platform.app.rpc.SettingsRpc',
  rpcName: 'uploadProfilePhoto',
  auth: 'external',
  fingerprint: 'dtTY6-OTAA3Ewi6COxqKI3OjsnBdk3FP',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const changePasswordRpc = {
  serviceName: 'com.hubspot.portals.platform.app.rpc.SettingsRpc',
  rpcName: 'changePassword',
  auth: 'external',
  fingerprint: 'IMkE38NjYSSBwHLCj2DS13OjsnBdk3FP',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPasswordStatusRpc = {
  serviceName: 'com.hubspot.portals.platform.app.rpc.SettingsRpc',
  rpcName: 'getPasswordStatus',
  auth: 'external',
  fingerprint: 'Yd4IT_EBtYYKUVrlDzjd73OjsnBdk3FP',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createOrUpdatePasswordRpc = {
  serviceName: 'com.hubspot.portals.platform.app.rpc.SettingsRpc',
  rpcName: 'createOrUpdatePassword',
  auth: 'external',
  fingerprint: 'wwtmWOh7rMLsz-rLIY1FbHOjsnBdk3FP',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};